import { API_URL } from 'utils/constants/app';
import { RequestHelper } from 'utils/helpers/RequestHelper';

const languageServiceUrl = `${API_URL}/language`;

const getLocales = () => RequestHelper.GET(`${languageServiceUrl}/locales`);

const localizationsUrl = `${languageServiceUrl}/localizations`;

const changeLocale = (data) => RequestHelper.POST(`${languageServiceUrl}/locale`, data);

export const LanguageService = {
  getLocales,
  localizationsUrl,
  changeLocale
};